import React from 'react';
import ShiftCard from './ShiftCard';
import type { Shift } from '../../dtos/scheduling/schedule.dto';
import { monthGrid, shiftsOnDay } from './scheduleUtils';

const MAX_PER_CELL = 3;
const HEAD = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export interface MonthViewProps {
  anchor: string;
  today: string;
  shifts: Shift[];
  onOpen: (shift: Shift) => void;
  onDay: (date: string) => void;
}

/** Month overview with "+N more" per day (plan §6.1); the day opens the agenda for that date. */
const MonthView: React.FC<MonthViewProps> = ({ anchor, today, shifts, onOpen, onDay }) => {
  const days = monthGrid(anchor);
  const month = anchor.slice(0, 7);
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="grid grid-cols-7 border-b border-gray-200 bg-gray-50">
        {HEAD.map((h) => <div key={h} className="px-2 py-2 text-xs font-semibold text-gray-600">{h}</div>)}
      </div>
      <div className="grid grid-cols-7">
        {days.map((d) => {
          const list = shiftsOnDay(shifts, d).filter((s) => s.date === d);
          const extra = list.length - MAX_PER_CELL;
          return (
            <div key={d} className={`min-h-[112px] border-b border-r border-gray-100 p-1 ${d.slice(0, 7) !== month ? 'bg-gray-50/70' : ''}`}>
              <button type="button" onClick={() => onDay(d)} className={`mb-1 flex h-7 min-w-[28px] items-center justify-center rounded-full px-1 text-xs font-medium ${d === today ? 'bg-sky-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`}>
                {Number(d.slice(8, 10))}
              </button>
              <div className="space-y-1">
                {list.slice(0, MAX_PER_CELL).map((s) => <ShiftCard key={s.id} shift={s} variant="compact" onOpen={onOpen} />)}
                {extra > 0 && <button type="button" onClick={() => onDay(d)} className="w-full text-left text-xs font-medium text-sky-700 hover:underline">+{extra} more</button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthView;
